import React, { useState } from 'react';
import AuthLayout from '../../components/Layout/AuthLayout'
import AuthNavigationPanel from '../../components/auth/AuthNavigationPanel'
import RegistrationForm from '../../components/auth/Forms/RregistrationForm'
import SocialButtonsPanel from '../../components/auth/SocialButtonsPanel'
import { ToastNotification } from '@carbon/react';

export default function RegistrationPage() {

  const [stateSuccess, setStateSuccess] = useState(false)
  const [isError, setIsError] = useState(false)


  function changeIsError() {
    setIsError(!isError)
    setTimeout(() => setIsError(false), 5000)
  }

  function changeStateSuccess() {
    setStateSuccess(!stateSuccess)
    setTimeout(() => setStateSuccess(false), 5000)
  }

  return (
    <AuthLayout>
      <AuthNavigationPanel label={'Регистрация'}/>
      {
        stateSuccess &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="success"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription=""
            subtitle={
              <span></span>
            }
            timeout={5000}
            title="Успешная регистрация, письмо с подтверждением профиля выслано вам на почту"
          />
        </div>
      }
      {
        isError &&
        <div style={{ position: 'fixed', top: 100, right: 0, zIndex: 1000 }}>
          <ToastNotification
            kind="error"
            hideCloseButton={false}
            lowContrast={false}
            iconDescription="При обновлении данных произошла ошибка"
            subtitle={
              <span>Произошла ошибка, попробуйте позже{" "}</span>
            }
            timeout={5000}
            title="Ошибка"
          />
        </div>
      }
      <RegistrationForm
        changeIsError={changeIsError}
        changeStateSuccess={changeStateSuccess}
      />
      <SocialButtonsPanel />
    </AuthLayout>
  )
}
